import React from "react";
import { t } from "ttag";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

export const FlagshipReviewsLink = (): React.ReactNode => {
    const onScrollToReviews = (event: React.MouseEvent<HTMLElement>) => {
        if (event) {
            event.preventDefault();
        }
        const document = getDocument();
        const reviews = document?.querySelector("#reviews");
        reviews?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <button
            className="pullquote__link scroll-on-page-link"
            onClick={onScrollToReviews}
        >
            {/* TODO(i18n): Include HTML entity in translation string to keep punctuation together: {t`See More Testimonials \u00BB`} */}
            {t`See More Testimonials`} &#187;
        </button>
    );
};
